import { Space } from "@mantine/core";
import { useNavigate } from "@tanstack/react-router";
import { useLiveQuery } from "dexie-react-hooks";
import { useEffect } from "react";
import { db } from "../db";
import { useChatId } from "../hooks/useChatId";
import { ChatRouteChild } from "./ChatRoute";

interface ChatRouteProps {
    hideHeader?: boolean;
    isCompact?: boolean;
}

export function ChatRoute({ hideHeader, isCompact }: ChatRouteProps = {}) {
    const navigate = useNavigate();
    const chatId = useChatId();

    useEffect(() => {
        if (window.location.hash === "#/") {
            navigate({ to: "/" });
        }
    }, [navigate]);

    const messages = useLiveQuery(() => {
        if (!chatId) return [];
        return db.messages.where("chatId").equals(chatId).sortBy("createdAt");
    }, [chatId]);

    return (
        <>
            {!isCompact && <Space h="lg" />}
            <ChatRouteChild
                chatId={chatId ?? undefined}
                messages={messages}
                hideHeader={hideHeader}
                isCompact={isCompact}
            />
        </>
    );
}
